import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UILink from 'UIComponents/link/UILink';
import PrerenderGlobals from './PrerenderGlobals';

const AchievementNotFound = ({
  brochureRoot,
  language
}) => {
  return /*#__PURE__*/_jsxs(UIErrorMessage, {
    "data-test-id": "achievement-public-not-found",
    type: "notFound",
    children: [/*#__PURE__*/_jsx(PrerenderGlobals, {
      language: language,
      wasFound: false
    }), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.certification.notFound"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
        href: brochureRoot,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.certification.backToAcademy"
        })
      })]
    })]
  });
};

export default AchievementNotFound;